import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "redux/store";

interface UdinState {
  udin_is_connected: boolean;
  showFirmsPopup: boolean;
  popupFirms: any[];
}

const initialState: UdinState = {
  udin_is_connected: false,
  showFirmsPopup: false,
  popupFirms: [],
};

const udinSlice = createSlice({
  name: "udin",
  initialState,
  reducers: {
    setUdinConnected(state, action: PayloadAction<boolean>) {
      state.udin_is_connected = action.payload;
    },
    showUdinFirmsPopup(state, action: PayloadAction<any[]>) {
      state.showFirmsPopup = true;
      state.popupFirms = action.payload;
    },
    hideUdinFirmsPopup(state) {
      state.showFirmsPopup = false;
      state.popupFirms = [];
    },
  },
});

export const selectUdinConnected = (state: RootState) => state.udin.udin_is_connected;
export const selectUdinFirmsPopup = (state: RootState) => ({
  showFirmsPopup: state.udin.showFirmsPopup,
  popupFirms: state.udin.popupFirms,
});
export const { setUdinConnected, showUdinFirmsPopup, hideUdinFirmsPopup } = udinSlice.actions;
export default udinSlice.reducer;
